'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupModal = exports.DeviceSetupModalUnwrapped = exports.modalConfig = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _DeviceSetupInformation = require('components/DeviceSetupModal/DeviceSetupInformation');

var _modals = require('redux/modules/modals');

var _bluetooth = require('decorators/Bluetooth/bluetooth.saga');

var _bound = require('redux/saga/entities/bound');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _DeviceSetupWelcome = require('components/DeviceSetupModal/DeviceSetupWelcome');

var _video = require('redux/modules/video');

var _DeviceSetupTagline = require('components/DeviceSetupModal/DeviceSetupTagline');

var _DeviceSetupPrepare = require('components/DeviceSetupModal/DeviceSetupPrepare');

var _DeviceSetupConnection = require('components/DeviceSetupModal/DeviceSetupConnection');

var _DeviceSetupCast = require('components/DeviceSetupModal/DeviceSetupCast');

var _DeviceUnsupported = require('components/DeviceSetupModal/DeviceUnsupported');

var _bluetooth2 = require('constants/bluetooth');

var _bluetooth3 = _interopRequireDefault(_bluetooth2);

var _deviceSetupModal = require('./device-setup-modal.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    alias: state.video.details && state.video.details.alias,
    userProfile: _bound.userProfile.data(state),
    device: state.video.device,
    chromecastConnected: state.video.casted
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  hideModal: _modals.hideModal,
  joinClass: _bluetooth.joinClass,
  loadDeviceSetup: _deviceSetupModal.loadDeviceSetup,
  updateDevice: _video.updateDevice
};

var modalConfig = exports.modalConfig = {
  headerClass: 'modal__device-modal',
  lightClose: true
};

var DeviceSetupModalUnwrapped = exports.DeviceSetupModalUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(DeviceSetupModalUnwrapped, _React$Component);

  function DeviceSetupModalUnwrapped(props) {
    var _this, _this3;

    (0, _classCallCheck3.default)(this, DeviceSetupModalUnwrapped);

    _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (DeviceSetupModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(DeviceSetupModalUnwrapped)).call(this, props)), _this3);

    _this3.onUnsupportedPlay = function () {
      _this.onStandardPlay(_bluetooth3.default.UNSUPPORTED);
    };

    _this3.onStandardPlay = function () {
      var deviceStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _bluetooth3.default.UNINITIALIZED;
      var _this$props = _this.props,
          alias = _this$props.alias,
          localHideModal = _this$props.hideModal,
          localJoinClass = _this$props.joinClass,
          localUpdateDevice = _this$props.updateDevice;


      if (global.BitmovinPlayer) {
        global.BitmovinPlayer.play('ui');
      }

      localUpdateDevice({
        enabled: false,
        status: deviceStatus
      });
      localJoinClass(alias, 'NON_INTERACTIVE');
      localHideModal('DeviceSetupModal');
    };

    _this3.state = { splash: true };
    return _this3;
  }

  (0, _createClass3.default)(DeviceSetupModalUnwrapped, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          device = _props.device,
          localLoadDeviceSetup = _props.loadDeviceSetup,
          localUpdateDevice = _props.updateDevice,
          localUserProfile = _props.userProfile;


      if (device.status !== _bluetooth3.default.UNSUPPORTED) {
        localLoadDeviceSetup();

        var profileComplete = localUserProfile && localUserProfile.weight && localUserProfile.weight.kg && localUserProfile.gender && localUserProfile.gender !== 'Unspecified' && localUserProfile.date_of_birth;
        var status = profileComplete ? _bluetooth3.default.INPUT_TAGLINE : _bluetooth3.default.INPUT_INFO_WELCOME;
        localUpdateDevice({ status: status });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.setState({ splash: false });
      }, 1000);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          device = _props2.device,
          onToggleHide = _props2.onToggleHide;

      // When the native chrome device picker is active, we want to hide our device setup modal.

      var nextStatus = nextProps.device.status;
      if (nextStatus !== device.status) {
        if (nextStatus === _bluetooth3.default.DEVICE_SELECTION || nextStatus === _bluetooth3.default.ATTEMPTING_TO_CAST) {
          onToggleHide();
        } else if (device.status === _bluetooth3.default.DEVICE_SELECTION || device.status === _bluetooth3.default.ATTEMPTING_TO_CAST) {
          onToggleHide(false);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          alias = _props3.alias,
          connectBluetoothDevice = _props3.connectBluetoothDevice,
          device = _props3.device,
          localHideModal = _props3.hideModal,
          localJoinClass = _props3.joinClass,
          onToggleHide = _props3.onToggleHide,
          localUpdateDevice = _props3.updateDevice,
          localUserProfile = _props3.userProfile,
          chromecastConnected = _props3.chromecastConnected;


      return _react2.default.createElement(
        'div',
        { className: 'modal__device-setup' },
        this.state.splash ? _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__splash anim anim--fadeInOut' },
          _react2.default.createElement('img', {
            src: require('../../../static/img/cp-live-white.svg'),
            alt: 'ClassPass Live'
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'anim anim--fadeIn' },
          device.status === _bluetooth3.default.UNSUPPORTED && _react2.default.createElement(_DeviceUnsupported.DeviceUnsupported, { handleStandardPlay: this.onUnsupportedPlay }),
          device.status === _bluetooth3.default.INPUT_INFO_WELCOME && _react2.default.createElement(_DeviceSetupWelcome.DeviceSetupWelcome, {
            updateDevice: localUpdateDevice
          }),
          device.status === _bluetooth3.default.INPUT_INFO && _react2.default.createElement(_DeviceSetupInformation.DeviceSetupInformation, {
            userProfile: localUserProfile
          }),
          device.status === _bluetooth3.default.INPUT_TAGLINE && _react2.default.createElement(_DeviceSetupTagline.DeviceSetupTagline, {
            image: localUserProfile.profile_image_url || require('../../../static/img/icon/avatar.svg'),
            username: localUserProfile.username
          }),
          device.status === _bluetooth3.default.PREPARE_WEARABLE && _react2.default.createElement(_DeviceSetupPrepare.DeviceSetupPrepare, {
            connectBluetoothDevice: connectBluetoothDevice,
            handleStandardPlay: this.onStandardPlay
          }),
          [_bluetooth3.default.DEVICE_CONNECTED, _bluetooth3.default.DEVICE_DISCONNECTED, _bluetooth3.default.DEVICE_SELECTION, _bluetooth3.default.DEVICE_FAILED, _bluetooth3.default.DEVICE_PAIRING_STAGE1, _bluetooth3.default.DEVICE_PAIRING_STAGE2].indexOf(device.status) > -1 && _react2.default.createElement(_DeviceSetupConnection.DeviceSetupConnection, {
            alias: alias,
            inSession: chromecastConnected,
            connectBluetoothDevice: connectBluetoothDevice,
            device: device,
            handleStandardPlay: this.onStandardPlay,
            hideModal: localHideModal,
            updateDevice: localUpdateDevice,
            joinClass: localJoinClass
          }),
          [_bluetooth3.default.READY_TO_CAST, _bluetooth3.default.ATTEMPTING_TO_CAST].indexOf(device.status) > -1 && _react2.default.createElement(_DeviceSetupCast.DeviceSetupCast, {
            alias: alias,
            hideModal: localHideModal,
            onToggleHide: onToggleHide,
            joinClass: localJoinClass,
            status: device.status,
            updateDevice: localUpdateDevice
          })
        )
      );
    }
  }]);
  return DeviceSetupModalUnwrapped;
}(_react2.default.Component);

DeviceSetupModalUnwrapped.propTypes = {
  alias: _propTypes2.default.string,
  chromecastConnected: _propTypes2.default.bool,
  connectBluetoothDevice: _propTypes2.default.func,
  device: _propTypes2.default.object,
  hideModal: _propTypes2.default.func,
  joinClass: _propTypes2.default.func,
  loadDeviceSetup: _propTypes2.default.func,
  onToggleHide: _propTypes2.default.func,
  updateDevice: _propTypes2.default.func,
  userProfile: _propTypes2.default.object
};

var DeviceSetupModal = exports.DeviceSetupModal = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Modal2.default)(modalConfig)(DeviceSetupModalUnwrapped));